module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize3-fe26675d11c32a864153550f1e8aef69.jpg";